import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="w-full bg-forest-900 px-6 pb-24 pt-10" data-id="element-156" data-mp="3r7punplj411c">
      <div className="mx-auto max-w-4xl text-center" data-id="element-157" data-mp="3raccqj61pyxt">
        <p className="flex items-center justify-center gap-2 font-display text-xl font-bold uppercase tracking-wide text-cream-50" data-id="element-158" data-mp="3mghkgrcdkbn4">
          <ShieldCheckIcon className="h-5 w-5 text-ember-400" aria-hidden="true" data-id="element-159" data-mp="3hi6c6l1qa970" />
          Surgical Shield System
        </p>
        <p className="mt-4 text-base text-cream-100/85" data-id="element-160" data-mp="38hrndbpk2byr">
          Built for Surgical Technology faculty who demand clinical rigor and their time back.
        </p>
        <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-cream-100/70" data-id="element-161" data-mp="33j6vq0odd0lx">
          Disclaimer: This is a digital pedagogical support tool for educators. Content must be adapted to
          local regulations and institutional policies. It does not constitute medical or legal advice.
        </p>
        <nav aria-label="Footer links" className="mt-6 flex justify-center gap-6 text-sm" data-id="element-162" data-mp="wq4ii3qkct5h">
          {[{
          label: 'Terms',
          href: '#terms'
        }, {
          label: 'Privacy',
          href: '#privacy'
        }, {
          label: 'Contact',
          href: '#contact'
        }].map(({
          label,
          href
        }) => <a key={label} href={href} className="text-cream-100/90 underline-offset-4 transition-colors duration-150 ease-out hover:text-cream-50 hover:underline" data-id="element-163" data-mp="vus7zzm1cuuw">
              {label}
            </a>)}
        </nav>
        <p className="mt-6 border-t border-white/15 pt-5 text-xs text-cream-100/70" data-id="element-164" data-mp="1tfwnn74kuutz">
          © 2026 Surgical Shield System — All Rights Reserved.
        </p>
      </div>
    </footer>;
}